/**
 * Feed Calculator
 * - Robust init (works with multiple sections on a page)
 * - Theme Editor support (section load)
 * - Formula: grams/day = weightKg * 1000 * (percent / 100)
 * - Rounding in grams (from data-rounding)
 * - Blocks & Balls conversion (from data-grams-per-block / data-grams-per-ball)
 * - Meals/day is fixed via data-meals (default: 2). No selector.
 */
(function () {
  function safeNumber(val) {
    if (val === null || val === undefined) return NaN;
    // allow "12,5" input
    var s = String(val).trim().replace(",", ".");
    var n = Number(s);
    return Number.isFinite(n) ? n : NaN;
  }

  function roundTo(value, rounding) {
    var r = Number(rounding || 1);
    if (!Number.isFinite(r) || r <= 0) r = 1;
    return Math.round(value / r) * r;
  }

  function formatGrams(g) {
    return Math.round(g).toLocaleString("da-DK") + " g";
  }

  function clamp(n, min, max) {
    if (!Number.isFinite(n)) return n;
    if (Number.isFinite(min)) n = Math.max(min, n);
    if (Number.isFinite(max)) n = Math.min(max, n);
    return n;
  }

  function formatCount(n) {
    if (!Number.isFinite(n)) return "—";
    // show 1 decimal for small values, else whole
    if (n > 0 && n < 10) return n.toFixed(1).replace(".", ",");
    return Math.round(n).toLocaleString("da-DK");
  }

  function initCalculator(root) {
    if (!root || root.__feedCalcInit) return;
    root.__feedCalcInit = true;

    var sectionId = root.getAttribute("data-section-id");
    var rounding = safeNumber(root.getAttribute("data-rounding")) || 5;
    var minWeight = safeNumber(root.getAttribute("data-min-weight"));
    var maxWeight = safeNumber(root.getAttribute("data-max-weight"));

    // Fixed meals/day (from data-meals) — default to 2
    var meals = parseInt(root.getAttribute("data-meals"), 10);
    if (!Number.isFinite(meals) || meals <= 0) meals = 2;

    var gramsPerBlock = safeNumber(root.getAttribute("data-grams-per-block"));
    var gramsPerBall = safeNumber(root.getAttribute("data-grams-per-ball"));

    // sensible fallbacks
    if (!Number.isFinite(gramsPerBlock) || gramsPerBlock <= 0) gramsPerBlock = 25;
    if (!Number.isFinite(gramsPerBall) || gramsPerBall <= 0) gramsPerBall = 10;

    var weightInput = document.getElementById("fc-weight-" + sectionId);
    var activitySelect = document.getElementById("fc-activity-" + sectionId);

    var dailyOut = root.querySelector("[data-fc-daily]");
    var perMealOut = root.querySelector("[data-fc-per-meal]");
    var metaOut = root.querySelector("[data-fc-meta]");

    var blocksDailyOut = root.querySelector("[data-fc-blocks-daily]");
    var ballsDailyOut = root.querySelector("[data-fc-balls-daily]");
    var blocksPerMealOut = root.querySelector("[data-fc-blocks-per-meal]");
    var ballsPerMealOut = root.querySelector("[data-fc-balls-per-meal]");

    function setEmpty() {
      if (dailyOut) dailyOut.textContent = "—";
      if (perMealOut) perMealOut.textContent = "—";
      if (metaOut) metaOut.textContent = "";

      if (blocksDailyOut) blocksDailyOut.textContent = "—";
      if (ballsDailyOut) ballsDailyOut.textContent = "—";
      if (blocksPerMealOut) blocksPerMealOut.textContent = "—";
      if (ballsPerMealOut) ballsPerMealOut.textContent = "—";
    }

    function setBlocksBalls(gramsPerDay) {
      // daily
      if (blocksDailyOut) {
        var blocksDay = gramsPerDay / gramsPerBlock;
        blocksDailyOut.textContent = "≈ " + formatCount(blocksDay) + " blokke";
      }
      if (ballsDailyOut) {
        var ballsDay = gramsPerDay / gramsPerBall;
        ballsDailyOut.textContent = "≈ " + formatCount(ballsDay) + " kugler";
      }

      // per meal
      var gramsPerMeal = gramsPerDay / meals;

      if (blocksPerMealOut) {
        var blocksMeal = gramsPerMeal / gramsPerBlock;
        blocksPerMealOut.textContent = "≈ " + formatCount(blocksMeal) + " blokke";
      }

      if (ballsPerMealOut) {
        var ballsMeal = gramsPerMeal / gramsPerBall;
        ballsPerMealOut.textContent = "≈ " + formatCount(ballsMeal) + " kugler";
      }
    }

    function calc() {
      if (!weightInput || !activitySelect || !dailyOut) return;

      var weightKg = safeNumber(weightInput.value);
      var percent = safeNumber(activitySelect.value);

      if (!Number.isFinite(weightKg) || weightKg <= 0) return setEmpty();
      if (!Number.isFinite(percent) || percent <= 0) return setEmpty();

      weightKg = clamp(weightKg, minWeight, maxWeight);

      var gramsPerDay = weightKg * 1000 * (percent / 100);
      gramsPerDay = roundTo(gramsPerDay, rounding);

      dailyOut.textContent = formatGrams(gramsPerDay);

      if (perMealOut) {
        var perMeal = gramsPerDay / meals;
        perMeal = roundTo(perMeal, rounding);
        perMealOut.textContent = formatGrams(perMeal);
      }

      setBlocksBalls(gramsPerDay);

      if (metaOut) {
        metaOut.textContent =
          "Beregnet ud fra " +
          percent +
          "% af kropsvægt pr. dag (" +
          meals +
          " måltid(er)).";
      }
    }

    ["input", "change"].forEach(function (evt) {
      if (weightInput) weightInput.addEventListener(evt, calc);
      if (activitySelect) activitySelect.addEventListener(evt, calc);
    });

    setEmpty();
    calc();
  }

  function initAll(scope) {
    var root = scope || document;
    root.querySelectorAll("[data-feed-calculator]").forEach(initCalculator);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (e) {
    if (!e || !e.target) return;
    initAll(e.target);
  });
})();
